<template>
    <card>
      <template slot="header">
        <h3 class="card-title">Loan & Contributions</h3>
     </template>
     <nav class="row">
       <div class="col-md-8">
          <ol class="breadcrumb arr-right bg-breadcrum">
             <li class="breadcrumb-item">
               <a href="#" @click="$router.push('/')"><i class="fa fa-home"></i>&nbsp;Dashboard</a>
              </li>
              <li class="breadcrumb-item active">Loan & Contributions List</li>
           </ol>
       </div>
        <div class="col-md-4">
            <router-link to="/hr/contributions/form" class="btn  btn-primary float-right"><i class="fa fa-plus"></i>&nbsp;Encode Loan & Contributions</router-link>
         </div>
     </nav>
       <hr style="margin-top:-10px"/>
          <div class="row">
              <div class="col-md-6">
                  <p><i class="fa fa-search"></i> Search Employee</p>
                  <input type="test" v-model="search" class="form-control" placeholder="Search..."> 
               </div>
              <div class="col-md-2">
                  <p><i class="fa fa-filter"></i> Filter By Year</p>
                  <select v-model="filter_by_year" @change="getYear" class="form-control" required>
                    <option v-for="year in years(2019)">{{ year }}</option>
                  </select>
               </div>
             <div class="col-md-2">
                    <div class="form-group">
                       <p><i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
                       <select v-model="page_limit" class="form-control" required>
                          <option value="">Default</option>
                          <option value="2">2</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="500">500</option>
                       </select>
                    </div>
             </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
                    <select v-model="order_by" class="form-control" required>
                        <option value="">Default</option>
                        <option value="1">ASC</option>
                        <option value="-1">DESC</option>
                    </select>
                  </div>
                </div>               
          </div>
       <hr>
      <!-- PAGINATION -->
      <b-pagination
          v-model="curentPage"
          :total-rows="items.length"
          :per-page="perPage"
          aria-controls="my-table"
          align="right"
          first-text="First"
          prev-text="Prev"
          next-text="Next"
          last-text="Last"
          ></b-pagination>
      <!-- END PAGINATION -->
      <hr>
       <div class="table-responsive ">
          <table class="table table-striped table-hover " v-loading="loading">
             <thead>
                <tr>
                   <th width="50">#</th>
                   <th width="300">Employee</th>
                   <th width="120">SSS CONTRB</th>
                   <th width="120">PHIC CONTRB</th>
                   <th width="120">HDMF CONTRB</th>
                   <th width="120">HMO</th>
                   <th width="120">SSS Loan</th>
                   <th width="120">HDMF Loan</th>
                   <th width="120">Tax</th>
                   <th width="120">Others</th>
                   <th width="180">Date Created</th>
                   <th width="180">Actions</th>
                   <th width="50"></th>
                </tr>
             </thead>
             <tbody>
                <!-- <template v-if="computedRequest == 0">
                        <td colspan="100%"><h4>  <i class="fa fa-database"></i> Empty Record ...</h4></td> 
                </template> -->
                <!-- <template v-if="computedRequest != 0">  -->
                   <tr v-for="item,index in computedRequest">
                        <td>{{index + 1}}</td>
                        <td>{{item.full_name}}</td>
                        <td>&#8369;{{item.sss_cont}}</td>
                        <td>&#8369;{{item.phic_cont}}</td>
                        <td>&#8369;{{item.hdmf_pagibig_cont}}</td>
                        <td>&#8369;{{item.hmo}}</td>
                        <td>&#8369;{{item.sss_loan}}</td>
                        <td>&#8369;{{item.hdmf_loan}}</td>
                        <td>&#8369;{{item.withholding_tax}}</td>
                        <td>&#8369;{{item.others}}</td>
                        <td> <i class="fa fa-calendar-o"></i> {{getDate(item.created_at)}}</td>  
                        <td>
                            <router-link :to="{name: 'contributions-details', params: { id: item.id, employee_id: item.employee_id}}" class="r-link"><i class="fa fa-eye"></i>&nbsp;View Details</router-link>
                        </td> 
                        <td>
                          <button class="btn btn-danger btn-xs" @click = "deleteItem(item.id, index)" v-b-tooltip.hover title="Remove Data from list"><i class="fa fa-times"></i></button>
                        </td>
                   </tr>
                 <!-- </template>   -->
             </tbody>
          </table><br/>
          <!-- PAGINATION NATIVE WAY -->
          <div class="row">
            <div class="col-md-6">
              <p style="color:#9a9a9a">Page {{curentPage}} out of {{total_item}} records</p>
            </div>
            <div class="col-md-6">
              <b-pagination
                  v-model="curentPage"
                  :total-rows="items.length"
                  :per-page="perPage"
                  aria-controls="my-table"
                  align="right"
                  first-text="First"
                  prev-text="Prev"
                  next-text="Next"
                  last-text="Last"
                  ></b-pagination>
            </div>
        </div>
     <!-- END PAGINATION -->
        </div>  
    </card>
 </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
components: {
  Card,
},

 data() {
    return {
      items: [],
      order_by: '',
     //PAGINATION
      page_limit: '',
      filter_by_year:'',
      start_page: 1,
      loading: true,
      perPage: 20,
      curentPage: 1,
      search: ''
    }
  },

  created: function () {
    setTimeout(() => {
      this.loading = false;
    }, 300);
  },

  beforeMount: function () {
    this.get_contributions();
  },

  methods: {
    deleteItem(id, index) {
     /* USING SWEET ALERT */
      this.$swal({
          title: 'Are you sure?',
          text: 'You can\'t revert your action',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes Delete it!',
          cancelButtonText: 'No, Keep it!',
          showCloseButton: false,
          showLoaderOnConfirm: true
          })
          .then((isConfirm) => {
            if (isConfirm === true) {
              axios.delete('api/contributions/remove/' + id)
                  .then(response => {
                    this.get_contributions(); // reloader 
                    this.$swal('Deleted', 'You successfully deleted this file', 'success')
              })
              .catch(response => {
                  console.log(response);
                  this.$swal('Error Code', 'Please contact Web developer', 'error')
              });
          }
        });
      },

    getYear(){
        if(this.filter_by_year == ''){
            this.get_contributions()
        }else{
            axios.get('api/contributions/' + this.filter_by_year)
            .then(response => {
                this.items = response.data;
                console.log(this.items)
            })
            .catch(error => {
                console.log(error.response)
            });
        } 
      },
      
    get_contributions() {
        axios.get('api/contributions')
        .then(response => {
          this.items = response.data
        })
        .catch(error => {
          console.log(error.response)
        });
    },

  },
  computed: {
    // PAGINATION
    offset() {
      return ((this.start_page - 1) * this.page_limit);
    },

    limit() {
      return ((this.offset + this.page_limit));
    },
    total_item() {
           return this.items.length
    },  
    computedRequest() {
      let filtered = this.items
       // USE IN PAGINATION 
      let start = (this.curentPage - 1) * this.perPage
      let end = this.curentPage * this.perPage
      filtered = filtered.slice(start, end)

      if (filtered.length > 0) {
        // SEARCH BY EMPLOYEE FULLNAME  
        if (this.search) {
          filtered = filtered.filter(
            item => item.full_name.toLowerCase().indexOf(this.search) > -1
          );
          return filtered
        }
        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered
        }
        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort((a, b) => a.full_name < b.full_name ? this.order_by : -this.order_by)
          return filtered
        }

      } else {
        filtered = 0
      }

      return filtered
    }
  },


}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-contributions/todo-contributions-list.vue